import { IApplicationState } from '../../types/redux';

export function getPriceForMeterFromDeveloperDisplay(state: IApplicationState) {
  const {
    newbuilding: { priceForMeterFromDeveloperDisplay },
  } = state;

  return priceForMeterFromDeveloperDisplay;
}
